import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FactoryItemsAddEdit, FactoryItemsListing } from './Pages';

export const FactoryItemsRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={FactoryItemsListing} />
        <Route exact path = {`${match.path}/AddEdit`} component={FactoryItemsAddEdit} />
    </Fragment>
)